import { Schema } from 'effect';

export const createOrderItemQuantitySchema = (min: number, max: number) =>
  Schema.FiniteFromString.check(Schema.isInt(), Schema.isBetween({ minimum: min, maximum: max }));
